import React, { useState } from "react";
import "../ComponentCss/faq.css";
import Header from "./Shared/Header";
import Footer from "./Shared/Footer";
import Breadcrumb from "./Breadcrumb";

const FAQAccordion = () => {
    // Initialize first accordion as open by default
    const [activeIndex, setActiveIndex] = useState(0);

    // FAQs data
    const faqs = [
        {
            id: 1,
            title: "How can I track my order?",
            content:
                "You will receive a tracking link via email or SMS once your order is shipped.",
        },
        {
            id: 2,
            title: "Are your products authentic?",
            content:
                "Absolutely! All our jewellery is crafted with certified materials, including hallmarked gold and authenticated gemstones.",
        },
        {
            id: 3,
            title: "AHow do I find the right size for rings or bracelets?",
            content:
                "We provide a size guide on our website to help you measure accurately. If you're unsure, contact us for assistance.",
        },
        {
            id: 4,
            title: 'What materials do you use in your jewellery?',
            content: 'We use high-quality materials like 18K and 22K gold, sterling silver, platinum, and ethically sourced diamonds and gemstones.',
        },
        {
            id: 5,
            title: 'What are your shipping options?',
            content: 'We offer standard and express shipping options. Shipping times and costs vary based on your location and order value.',
        },
        {
            id: 6,
            title: 'Is my order insured during shipping?',
            content: 'Yes, all orders are fully insured until they reach your doorstep.',
        },
        {
            id: 7,
            title: 'What payment methods do you accept?',
            content: 'We accept major credit/debit cards, UPI, net banking, and digital wallets. EMI options are also available for select purchases.',
        },
        {
            id: 8,
            title: 'Do you offer jewellery repair services?',
            content: 'Yes, we provide professional cleaning and repair services for our jewellery. Contact our support team for more details.',
        },
    ];

    // Toggle the active accordion
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <>
            <Header />
            <section className="contact-banner-sec">
                <div className="container-fluid">
                    <div className="page-header">
                        <h1>FAQ</h1>
                    </div>
                    <Breadcrumb currentLabel="FAQ" />
                </div>
            </section>
            <section className="faq_wepper">
                <div className="accordion" id="accordionExample">
                    {faqs.map((faq, index) => (
                        <div className="accordion-item" key={faq.id}>
                            <h2 className="accordion-header">
                                <button
                                    className={`accordion-button ${activeIndex === index ? "" : "collapsed"
                                        }`}
                                    type="button"
                                    onClick={() => toggleAccordion(index)}
                                    aria-expanded={activeIndex === index}
                                >
                                    {faq.title}
                                    <img
                                        className="icon"
                                        src={
                                            activeIndex === index
                                                ? "images/close.png" // Icon for expanded state
                                                : "images/plus.png" // Icon for collapsed state
                                        }
                                        alt={activeIndex === index ? "Close" : "Open"}

                                    />
                                </button>
                            </h2>
                            <div
                                className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""
                                    }`}
                            >
                                <div className="accordion-body">
                                    <p>{faq.content}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <Footer />
        </>
    );
};

export default FAQAccordion;
